import React, {Fragment, useEffect, useState} from 'react';
import {Button, Card, Flex, Skeleton, theme, Typography} from 'antd';
import TnCDialog from './TnCDialog';
import FieldsItem from './FieldsItem';
import {api} from 'GQL/MethodsBFF/Transactions';
import {BackButtonWText, SnackBar} from 'Components';
import parse from 'html-react-parser';
import {useSnackBar} from 'Hooks';
import {useSelector} from 'react-redux';

interface IProps {
  toggleView: any;
  transactionId: string | null;
  csData?: any;
}

const DetailView: React.FC<IProps> = (props) => {
  const {toggleView, transactionId, csData} = props;
  const {token} = theme.useToken();
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const {selectedMember} = useSelector((state: any) => state?.selectedMember);
  const currentMemberDetails = selectedMember.currentMemberDetails;
  const [transactionDetails, setTransactionDetails] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);
  const [isSnackBarOpen, closeSnackBar] = useSnackBar(error);

  const toggleTnDDialog = () => {
    setIsDialogVisible(!isDialogVisible);
  };

  const _handleResponse = (data, error) => {
    setLoading(false);
    error && setError(error.message);
    data && setTransactionDetails(data);
  };

  useEffect(() => {
    (async () => {
      const data = await api.gqlTransactionDetails({
        ngMemberId: currentMemberDetails?.memberId,
        referenceId: currentMemberDetails?.externalRefId,
        offerId: transactionId,
      });
      _handleResponse(data.getTransactionDetailsByReferenceId?.[0], data.error);
    })();
  }, []);

  if (loading) {
    return <Skeleton active paragraph={{rows: 4}} />;
  } else if (error) {
    return (
      <SnackBar
        errorMessage={error}
        isSnackBarOpen={isSnackBarOpen}
        closeSnackBar={closeSnackBar}
      />
    );
  } else {
    return (
      <Card style={{padding: 16}} styles={{body: {padding: 0}}}>
        <Fragment>
          <Flex justify="space-between" align="center" style={{marginBottom: 16}}>
            <BackButtonWText
              text={'Back to list'}
              callback={toggleView}
              color={token.colorPrimary}
            />
            <Typography.Text>
              Type: <span style={{fontFamily: 'semi-bold'}}>{transactionDetails.offerType}</span>
            </Typography.Text>
          </Flex>
          <Typography.Title level={2} style={{padding: '16px 0'}}>
            {transactionDetails.titleShort}
          </Typography.Title>
          <Typography.Text>{parse(transactionDetails.description)}</Typography.Text>
          <Button
            type="link"
            onClick={() => toggleTnDDialog()}
            style={{padding: 0, height: 'auto'}}>
            <Typography.Text style={{textDecoration: 'underline'}}>
              {csData.tnc_button_title}
            </Typography.Text>
          </Button>

          <Typography.Text strong style={{display: 'block', fontSize: 16, margin: '20px 0 4px'}}>
            {csData.fields_heading}
          </Typography.Text>
          <div style={{display: 'flex', flexWrap: 'wrap', columnGap: '5%', rowGap: 0}}>
            {Object.entries(transactionDetails).map((item: any, index) => (
              <FieldsItem
                fieldKey={item[0]}
                value={item[1]}
                key={index}
                csFieldMap={csData.field_map}
              />
            ))}
            {transactionDetails.offerType.toLowerCase() === 'cashback' && (
              <FieldsItem
                fieldKey={'rebate'}
                value={transactionDetails.titleShort}
                csFieldMap={csData.field_map}
              />
            )}
          </div>
          <TnCDialog
            toggleTnDDialog={toggleTnDDialog}
            isDialogVisible={isDialogVisible}
            transactionDetails={transactionDetails}
          />
        </Fragment>
      </Card>
    );
  }
};

export default DetailView;
